import { render, staticRenderFns } from "./InventoryDailySnapshotLogs.vue?vue&type=template&id=2634b238"
import script from "./InventoryDailySnapshotLogs.vue?vue&type=script&lang=js"
export * from "./InventoryDailySnapshotLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports